// fetchMessageRating.js
'use strict';
import fetch from '../resource/customFetch.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';
import getMeData from '../selector/getMeData.js';
import {
  ADD_MESSAGE,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch message rating
 * @kind action
 * @param {string} {id} - message id.
 * @return {Promise} Action promise.
 */
const fetchMessageRating =
  ({ id }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');

    if (!token) {
      return dispatch({ type: '' });
    }

    const selectPath = ['messages', id, 'rating'];

    const url = getResourceUrl({ endpoint: `/messages/${id}/rate` });
    const fetchOptions = {
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      const { rating: ratedAs } = await response.json();
      dispatch({ type: ADD_MESSAGE, payload: { id, ratedAs } });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchMessageRating;
